import { StudyKeyConfig, StudyUpdatedStatus } from './types';

/* eslint-disable no-shadow, no-unused-vars */
export enum HttpResponse {
  OK = 200,
  NotFound = 404,
  ErrorOrUnknown = 0
}

// eslint-disable-next-line import/prefer-default-export
export const QC_OPTIONS = [
  { label: 'To QC', value: 'to_qc' },
  { label: 'QCed', value: 'qced' },
  { label: 'No Document', value: 'no_document' },
  { label: 'Section 14 Unavailable', value: 'sec_14_missing' },
  { label: 'Escalate', value: 'escalate' },
  { label: 'Need Manual Review', value: 'need_manual_review' }
];

export const STUDY_KEY_TITLE: Record<string, StudyKeyConfig> = {
  study_updated_status: {
    title: 'Study Updated Status',
    inputType: 'radio-group',
    default: null,
    options: [
      { label: 'New', value: 'new' },
      { label: 'Modified', value: 'modified' },
      { label: 'Not Modified', value: 'not-modified' }
    ]
  },
  has_combined_study_data: {
    title: 'Has Combined Study Data',
    inputType: 'radio-group',
    default: false,
    options: [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ]
  },
  combined_study_count: {
    title: 'Combined Study Count',
    inputType: 'number',
    default: null,
    options: []
  },
  blinding: {
    title: 'Blinding',
    inputType: 'text',
    default: null,
    options: ['Open-Label', 'Single', 'Double', 'Triple', 'Quadruple']
  },
  center: { title: 'Center', inputType: 'text', default: null, options: ['Single', 'Multi'] },
  control: { title: 'Control', inputType: 'text', default: null, options: ['Placebo', 'Active'] },
  randomized: {
    title: 'Is Randomized',
    inputType: 'radio-group',
    default: true,
    options: [
      {
        label: 'Yes',
        value: true
      },
      {
        label: 'No',
        value: false
      }
    ]
  }
};

export const ATTRIBUTE_MAPPING: any = {
  duration: {
    type: 'number'
  },
  numberofarms: {
    type: 'number'
  },
  samplesize: {
    type: 'number'
  },
  durationunit: {
    options: ['msec', 'sec', 'mins', 'hrs', 'days', 'weeks', 'months', 'years']
  },
  primaryendpoint: {
    descriptionEnabled: true,
    altTitle: 'Primary EP'
  },
  secondaryendpoint: {
    descriptionEnabled: true,
    altTitle: 'Sec. EP'
  }
};

/**
 * Resolves NCT ID and Identifier attribute IDs from backend attribute definitions.
 * Returns null for each when no matching attribute name is found.
 */
export function getNctAndIdentifierAttributeIds(
  attributes: Array<{ attribute_id: number; attribute_name: string }>
): {
  nctIdAttributeId: number | null;
  identifierAttributeId: number | null;
} {
  const nctAttr = attributes.find(a => a.attribute_name === 'NCT ID');
  const identifierAttr = attributes.find(a => a.attribute_name === 'Identifier');
  return {
    nctIdAttributeId: nctAttr ? nctAttr.attribute_id : null,
    identifierAttributeId: identifierAttr ? identifierAttr.attribute_id : null
  };
}

export const ATTRIBUTE_ORDER = [
  'study_updated_status',
  'blinding',
  'center',
  'randomized',
  'control',
  'has_combined_study_data',
  'combined_study_count'
];

export const BOOLEAN_RADIO_GROUP_OPTIONS = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

export const STUDY_UPDATED_STATUS_LABELS: Record<StudyUpdatedStatus, string> = {
  new: 'New',
  modified: 'Modified',
  'not-modified': 'Not Modified'
};

export const STUDY_UPDATED_STATUS_TOOLTIPS: Record<StudyUpdatedStatus, string> = {
  new: 'This study was not present in the previous indication.',
  modified:
    'This study existed in the previous indication and tracked fields changed. Review and update as needed.',
  'not-modified': 'This study existed in the previous indication with no tracked field changes.'
};

/** Radio / select options for study_updated_status. */
export const STUDY_UPDATED_STATUS_OPTIONS: Array<{ label: string; value: StudyUpdatedStatus }> = [
  { label: 'New', value: 'new' },
  { label: 'Modified', value: 'modified' },
  { label: 'Not Modified', value: 'not-modified' }
];

/** MUI Chip color for each study_updated_status value. */
export const STUDY_UPDATED_STATUS_CHIP_COLOR: Record<
  StudyUpdatedStatus,
  'success' | 'warning' | 'default'
> = {
  new: 'success',
  modified: 'warning',
  'not-modified': 'default'
};

export const CENTER_MAPPING: any = {
  cber: 'CBER',
  cder: 'CDER'
};

export const CENTER_OPTIONS: any = [
  { label: 'All', value: 'all' },
  { label: 'CDER', value: 'cder' },
  { label: 'CBER', value: 'cber' }
];
